const resourcesData = {
	view: [
		{
			title: 'Guide til facilitering',
			file: 'resurser-basal-guide-2026.pdf'
		}
	],
	download: [
		{
			title: 'M1 spørgsmål, Den svære cirkel',
			file: 'resurser-m1-spoergsmaal-til-den-svaere-cirkel.pdf'
		},
		{
			title: 'M1 navne, Den svære cirkel',
			file: 'resurser-m1-navne-den-svaere-cirkel.pdf'
		},
		{
			title: 'M1 Send-aben-videre-cirkel',
			file: 'resurser-m1-send-aben-videre-cirkel.pdf'
		},
		{
			title: 'M3-7 Basalplan-plancher',
			file: 'resurser-m3-7-basalplan-plancher-a3.pdf'
		},
		{
			title: 'M3-6 Basalplanskabelon',
			file: 'resurser-m3-6-basalplanskabelon.pdf'
		},
		{
			title: 'M4 Lyttekort',
			file: 'resurser-m4-lyttekort.pdf'
		},
		{
			title: 'M4 Dialoger',
			file: 'resurser-m4-dialoger.pdf'
		},
		{
			title: 'M6 Følelsesmemory',
			file: 'resurser-m6-foelelsesmemory.pdf'
		},
		{
			title: 'M7 Basalplanskabelon',
			file: 'resurser-m7-basalplanskabelon.pdf'
		},
		{
			title: 'M7 Cases',
			file: 'resurser-m7-cases.pdf'
		},
		{
			title: 'M8 Basalplan-plancher',
			file: 'resurer-m8-basalplan-plancher-a3.pdf'
		},
		{
			title: 'M8 Pointskema',
			file: 'resurser-m8-pointskema.pdf'
		},
		{
			title: 'Elevhæfte',
			file: 'resurser-basal-elevhaefte-2026.pdf'
		}
	]
};
	

export {
	resourcesData
};